<div class="no-styling" [innerHTML]="job?.description?.en | sanitizeHtml"></div>
